<template lang="pug">
Fragment
  b-row
    b-col(cols='1')
      BackArrow
    b-col(cols='11').d-flex.flex-column.align-items-start.mb-2
      h4.title Mantenedor de partes
      nav.breadcrumb-custom
        span Inicio
        span.separator /
        span Control de Inventario
        span.separator /
        span Mantenedor de partes
  PartsList( @stop-loading="loading = false" )
</template>

<script>
import BackArrow from '../../components/UI/BackArrow.vue'
import PartsList from '../../components/Inventory/PartsList.vue'

export default {
  name: 'Parts',
  components: {
    BackArrow,
    PartsList,
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.title {
  color: $samtek-black;
  font-size: 20px;
  font-weight: 700;
}

.breadcrumb-custom {
  margin-top: 8px;
  font-size: 15px;
  color: $samtek-grey;
}

.breadcrumb-custom .separator {
  margin: 0 6px;
}

::v-deep .back-arrow {
  color: $samtek-yellow !important;
  font-size: 24px;
  border-radius: 5px;
}
</style>
